import { render, staticRenderFns } from "./cargoOfficeSelect.vue?vue&type=template&id=0654621c&"
import script from "./cargoOfficeSelect.vue?vue&type=script&lang=js&"
export * from "./cargoOfficeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0654621c')) {
      api.createRecord('0654621c', component.options)
    } else {
      api.reload('0654621c', component.options)
    }
    module.hot.accept("./cargoOfficeSelect.vue?vue&type=template&id=0654621c&", function () {
      api.rerender('0654621c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standard/cargoOfficeSelect.vue"
export default component.exports